<ion-content>
  <ion-list>
    <form [formGroup]="form">
      <ion-item>
        <ion-input type="text" label="{{'Venue name' | translate}}" labelPlacement="floating" formControlName="venueName"></ion-input>
      </ion-item>

      <ion-item>
        <ion-input type="text" label="{{'Venue abbreviation' | translate}}" labelPlacement="floating" formControlName="venueAbbreviation"></ion-input>
      </ion-item>

      <ion-button class="ion-margin" (click)="create()" expand="block" color="primary">
        {{'Create venue' | translate}}
      </ion-button>
    </form>
  </ion-list>
</ion-content>